function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconB2BOpen = function SvgIconB2BOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M101.593 179.071a16 16 0 1 1 16-16 16.018 16.018 0 0 1-16 16Zm0-29.694a13.694 13.694 0 1 0 13.694 13.694 13.709 13.709 0 0 0-13.694-13.694Z",
    transform: "translate(-85.593 -147.071)",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.834,
    cy: 1.834,
    r: 1.834,
    transform: "translate(14.166 14.166)",
    style: {
      fill: "#9c9c9c"
    }
  }));
};
export default SvgIconB2BOpen;